<template>
	<div>
		<el-dialog :visible.sync="selectwin" :width="width" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<div>
				<el-form size="mini">
					<el-form-item :label="label" label-width="80px">
						<el-select v-model="selectval" style="width:220px" filterable>
							<el-option v-for="(item,index) in selectitem" :key="index" :label="item.title" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<div style="text-align:center;width:100%;padding-top:10px">
					<el-button size="mini" type="success" @click.native="sure">{{$lang.label.public.sure}}</el-button>
					<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="selectwin=false">{{$lang.label.public.cancel}}</el-button>
				</div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		width:{
			type:String,
			default:'300px'
		}
	},
	data() {
		return{
			selectwin:false,
			selectval:'',
			selectitem:[],
			label:'',
			title:'',
			controlid:'',
			fun:''
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/transport.scss');
		//this.init();
	},
	methods:{
		init(param){
			if(param.selectitem!=undefined){
				this.selectwin=true;
				this.selectitem=param.selectitem;
			}
			if(param.label!=undefined)
				this.label=param.label;
			if(param.title!=undefined)
				this.title=param.title;
			if(param.controlid!=undefined)
				this.controlid=param.controlid;
			if(param.fun!=undefined)
				this.fun=param.fun;
		},
		sure(){
			if(this.selectval!='')
			{
				this.selectwin=false;
				this.$emit('selectitemcallback',{value:this.selectval,controlid:this.controlid,fun:this.fun});
			}
		}
	}
}
</script>

<style>
</style>